module.exports = __webpack_public_path__ + "static/SFMono-Regular-7faa66605357721067fe1b07d9103015.woff2";